/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Add_Player_More_ResultsInputs */



/**
* | output |
* | --- |
* | "{count} more — refine your search" |
*
* @param {Add_Player_More_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const add_player_more_results = /** @type {((inputs: Add_Player_More_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Player_More_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} de plus — affinez votre recherche`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} más — refine su búsqueda`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Mais ${i?.count} — refine sua busca`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} altri — affina la ricerca`)
	return /** @type {LocalizedString} */ (`${i?.count} more — refine your search`)
});